import { actionCreator } from 'utils';
import * as FormVersionTypes from '../types/formVersionTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    limit: 50,
    offset: 0,
    isSubmittingErrorReport: false,
    isCreatingJobResults: false,
    deleteFormVersionId: [],
    deletedFVS: [],
    isReportErrorPopupVisible: false,
    sort: {
        key: 'start_date',
        type: 'asc',
    },
    rollOut: {
        loading: false,
        error: false,
        success: false,
    },
    filters: {
        formVersionId: '',
        formId: '',
        jobId: '',
        designId: '',
        orderItemId: '',
        rollOut: '',
        rollType: undefined,
        customer: '',
        carpetQuality: '',
        width: '',
        height: '',
        machine_ids: undefined,
        startDate: [],
        expectedEndDate: [],
        status: 'NOT_DONE',
        quantity: '',
        withBorder: undefined,
        reprint: undefined,
    },
    selected: [],
};

export default function (state = initState, action) {
    switch (action.type) {
    case FormVersionTypes.LOAD_FORM_VERSIONS:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(FormVersionTypes.LOAD_FORM_VERSIONS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(FormVersionTypes.LOAD_FORM_VERSIONS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case FormVersionTypes.SET_FORM_VERSIONS_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(FormVersionTypes.SET_FORM_VERSIONS_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case FormVersionTypes.SET_FORM_VERSIONS_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case FormVersionTypes.SET_FORM_VERSIONS_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case FormVersionTypes.RESET_FORM_VERSIONS_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case FormVersionTypes.SELECT_FORM_VERSION_FOR_ROLL_OUT:
        return Object.assign({}, state, {
            selected: action.form,
        });

    case FormVersionTypes.CREATE_ROLL_OUT:
        return Object.assign({}, state, {
            rollOut: Object.assign({}, state.rollOut, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(FormVersionTypes.CREATE_ROLL_OUT, 'res'):
        return Object.assign({}, state, {
            rollOut: Object.assign({}, state.rollOut, {
                loading: action.loading,
                success: action.success,
                error: false,
            }),
        });

    case actionCreator(FormVersionTypes.CREATE_ROLL_OUT, 'err'):
        return Object.assign({}, state, {
            rollOut: Object.assign({}, state.rollOut, {
                loading: false,
                success: false,
                error: action.error,
            }),
        });

    case FormVersionTypes.CREATE_JOB_RESULTS:
        return Object.assign({}, state, {
            isCreatingJobResults: true,
        });

    case actionCreator(FormVersionTypes.CREATE_JOB_RESULTS, 'res'):
        return Object.assign({}, state, {
            isCreatingJobResults: false,
        });

    case actionCreator(FormVersionTypes.CREATE_JOB_RESULTS, 'err'):
        return Object.assign({}, state, {
            isCreatingJobResults: false,
        });

    case FormVersionTypes.REPORT_JOB_ERROR:
        return Object.assign({}, state, {
            isSubmittingErrorReport: true,
        });

    case actionCreator(FormVersionTypes.REPORT_JOB_ERROR, 'res'):
        return Object.assign({}, state, {
            isSubmittingErrorReport: false,
            isReportErrorPopupVisible: action.closePopup ? false : state.isReportErrorPopupVisible,
        });

    case actionCreator(FormVersionTypes.REPORT_JOB_ERROR, 'err'):
        return Object.assign({}, state, {
            isSubmittingErrorReport: false,
        });

    case FormVersionTypes.REPORT_ERROR_POPUP_VISIBILITY:
        return Object.assign({}, state, {
            isReportErrorPopupVisible: action.data,
        });

    case FormVersionTypes.DELETE_FORM_VERSION:
        return Object.assign({}, state, {
            deleteFormVersionId: action.id,
        });

    case actionCreator(FormVersionTypes.DELETE_FORM_VERSION, 'res'):
        return Object.assign({}, state, {
            deleteFormVersionId: [],
            deletedFVS: action.id,
        });

    case actionCreator(FormVersionTypes.DELETE_FORM_VERSION, 'err'):
        return Object.assign({}, state, {
            deleteFormVersionId: [],
        });

    default:
        return state;
    }
}
